<template>
  <v-app>
    <v-content>
      <v-parallax
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
        height="550"
        id="bg1"
        :src="require('@/assets/main.jpg')"
      >
        <v-row class="align-center justify-center">
          <v-col data-aos="fade-down" class="col-12">
            <p class="text-center display-4">Janne Karppinen</p>
          </v-col>
        </v-row>
      </v-parallax>
      <v-row class="mt-5">
        <v-col data-aos="fade-in" class="col-12">
          <p class="display-2 text-center">About me</p>
        </v-col>
      </v-row>
      <v-row class="mt-n5">
        <v-col data-aos="fade-in" class="col-12 text-center" id="me-img">
          <img src="@/assets/me.png" />
        </v-col>

        <v-col data-aos="fade-right" class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-container">
              <v-card-text class="subtitle-1 text--primary">
                <p>"I am a Bachelor of business Administration from Kerava who is passionate about PC hardware, programming, web development and is looking for new challenges. I see myself as a relentless problem solver and I am eager to develop myself in whatever I am doing.</p>
                <p>I am currently looking for a junior developer job which surely opens more possibilities for me in the future. Most of my experience is from my free time projects.</p>
                <p>Besides programming I also play guitar, keyboard and drums. I am a guitarist in a folk metal band. Recording and audio production also interests me."</p>
                <v-col class="flex-row">
                  <v-icon large>email</v-icon>hypetremethewanderer@gmail.com
                </v-col>
                <v-col class="flex-row">
                  <v-icon large color="red darken-1">video_library</v-icon>www.youtube.com/hypetreme
                </v-col>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-parallax height="550" id="bg2" :src="require('@/assets/main2.jpg')">
        <v-row class="align-center justify-center">
          <v-col class="col-12"></v-col>
        </v-row>
        <v-row class="align-baseline">
          <v-col data-aos="fade-in" class="col-12">
            <p class="text-center display-3">Some profound quote here.</p>
            <v-col class="text-center"></v-col>
          </v-col>
        </v-row>
      </v-parallax>
      <v-row data-aos="fade-in" class="mt-5">
        <v-col class="col-12">
          <p class="display-2 text-center">Projects</p>
        </v-col>
      </v-row>
      <v-row class="mt-n5">
        <v-col data-aos="fade-in" class="col-12 text-center" id="git-img">
          <img src="@/assets/git.png" />
        </v-col>
        <v-col data-aos="fade-right" class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="http://www.jannehkarppinen.fi/teostokeikat"
                target="_blank"
                :elevation="5"
              >Teostokeikat</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>Search by city and find all shows from years 2014-2017 that have been informed to Teosto. Lists event name, place and date. This is a good example of using Vuetify.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags1" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="https://boiling-fjord-77485.herokuapp.com/"
                target="_blank"
                :elevation="5"
              >Game Database</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>
                  A visual example of showing data from SQLite3 database with Django and Vue.js. Hosted in Heroku.
                  Basically just a practise for using Vue.js, Django and Heroku together.
                </p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags2" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="https://github.com/Hypetreme/api-example"
                target="_blank"
                :elevation="5"
              >API Example</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>API endpoint example. Get movie's info from https://www.omdbapi.com or book's info from https://openlibrary.org. An API example with JWT auth token.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags3" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col data-aos="fade-right" class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="http://pauper.arkku.net/pauperci"
                target="_blank"
                :elevation="5"
              >Magic Card Database</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>A website for Magic the Gathering cards. Allows you to search for common cards and put them in categories. These categories give you an idea how good an invidual card would be. This was an old plain PHP project I almost fully converted to Codeigniter.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags4" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="https://jannehkarppinen.fi/ottelu/login"
                target="_blank"
                :elevation="5"
              >Otteluohjelma</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>Intership project for Appstudios Finland Oy. Service for adding sports team, players and events. Fans can then view event details with their mobile devices via link.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags5" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="https://jannehkarppinen.fi/weather"
                target="_blank"
                :elevation="5"
              >Weather</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>A school project. Check weather statuses all over the world by city or country. The site changes color and icon according to the weather. A practise for using AJAX call.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags6" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col data-aos="fade-right" class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <div class="text-center">
              <v-btn
                class="white--text"
                color="purple"
                href="https://github.com/Hypetreme/VaultsOfWoe"
                target="_blank"
                :elevation="5"
              >Vaults of Woe</v-btn>
            </div>
            <div class="text-container">
              <v-card-text class="body-1">
                <p>A school project. Text fighting game with a graphical UI.</p>
              </v-card-text>
            </div>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip small v-for="tag in tags7" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-parallax height="550" id="bg2" :src="require('@/assets/main2.jpg')">
        <v-row class="align-center justify-center">
          <v-col class="col-12"></v-col>
        </v-row>
        <v-row class="align-baseline">
          <v-col data-aos="fade-in" class="col-12">
            <p class="text-center display-3">All my projects in GitHub</p>
            <v-col class="text-center">
              <v-btn
                color="primary"
                href="http://www.github.com/Hypetreme?tab=repositories"
                target="_blank"
                :elevation="5"
              >See Projects</v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-parallax>
      <v-row class="mt-5">
        <v-col data-aos="fade-in" class="col-12">
          <p class="display-2 text-center">Education</p>
        </v-col>
      </v-row>
      <v-row data-aos="fade-right" class="mt-n5">
        <v-col class="col-12 text-center">
          <v-icon id="edu-img" color="purple" x-large>local_library</v-icon>
        </v-col>
        <v-col class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <v-card-title
              class="align-center justify-center"
            >Bachelor of Business Administration (Tradenomi)</v-card-title>
            <v-card-text class="text-center body-1">
              <p>Laurea 2014-2018</p>
            </v-card-text>
            <v-col class="text-center">
              <v-btn
                class="white--text mr-4"
                color="purple"
                href="https://www.theseus.fi/bitstream/handle/10024/147277/oppari_janne_karppinen.pdf?sequence=1&isAllowed=y"
                target="_blank"
                :elevation="5"
              >See thesis</v-btn>
              <v-btn
                class="white--text ml-4"
                color="purple"
                href="assets/todistus.pdf"
                target="_blank"
                :elevation="5"
              >See courses</v-btn>
            </v-col>
            <v-card-text>
              <v-chip-group multiple column active-class="primary--text">
                <v-chip v-for="tag in eduTags" :key="tag">{{ tag }}</v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="col-12 d-sm-flex">
          <v-card class="mx-auto" max-width="500" :elevation="0">
            <v-card-title
              class="align-center justify-center"
            >The Fundamentals of Digital Marketing Certificate</v-card-title>
            <v-card-text class="text-center body-1">
              <p>Google Digital Carage</p>
              <p>Certificate ID: YSW RPW PGX</p>
            </v-card-text>
            <v-col class="text-center">
              <v-btn
                class="white--text mr-4"
                color="purple"
                href="https://learndigital.withgoogle.com/digitalgarage/validate-certificate-code"
                target="_blank"
                :elevation="5"
              >See Authenticity</v-btn>
            </v-col>
            <v-card-text></v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-content>
    <v-footer color="white" class="align-center justify-center">
      <div>Janne Karppinen &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    tags1: ['Vue.js', 'Vuetify', 'Axios', 'API'],
    tags2: ['Python', 'Django', 'Vue.js', 'Vuetify', 'Axios', 'API'],
    tags3: ['PHP', 'JWT', 'Auth', 'API'],
    tags4: ['PHP', 'Codeigniter', 'API'],
    tags5: ['PHP', 'Javascript', 'JQuery', 'Vex'],
    tags6: ['Javascript', 'AJAX', 'API'],
    tags7: ['Java'],
    eduTags: [
      'Development and visual design of websites',
      'Database management',
      'User-centered Design',
      'Defining and designing a software project',
      'Usability testing of application',
      'Audiovisual Production',
      'Student exchange'
    ]
  })
};
</script>
<style>
.v-content {
  background-color: white !important;
}
#bg1 .v-parallax__image-container {
  height: 130%;
}
#bg2 .v-parallax__image-container {
  height: 170%;
}
#git-img img {
  height: 100px;
}
#me-img img {
  height: 130px;
}
#edu-img {
  font-size: 100px !important;
}
</style>